import { forEach } from 'lodash';
import {
    IMPRESSION_ITEM_ATTR,
    IMPRESSION_PARENT_ATTR,
    ITEM_WITHOUT_CONTAINER_SELECTOR
} from '../useImpressionContainer/consts';
import { MANAGER_ELEMENT } from './consts';

export const calculateRelativeItemSize = (itemRef, containerRef) => {
    const rootRef = containerRef || MANAGER_ELEMENT;

    if (!rootRef) {
        return;
    }

    const rootBounds = rootRef.getBoundingClientRect();
    const itemBounds = itemRef.getBoundingClientRect();
    const { width: containerWidth, height: containerHeight } = rootBounds;
    const { width: itemWidth, height: itemHeight } = itemBounds;

    const x = Math.round(itemWidth / containerWidth * 100) / 100;
    const y = Math.round(itemHeight / containerHeight * 100) / 100;

    return { x, y };
};

export const getEmptyContainerObject = () => ({ registered: false, items: [] });

export const calculateElementPositionInParent = (containerId, impId) => {
    const element = document.querySelector(`[${IMPRESSION_ITEM_ATTR}="${impId}"]`);
    const elementRect = element?.getBoundingClientRect();

    if (!element) {
        return -1;
    }

    let position = 1;
    const itemsSelector = containerId ? `[${IMPRESSION_PARENT_ATTR}="${containerId}"]` : ITEM_WITHOUT_CONTAINER_SELECTOR;

    forEach(document.querySelectorAll(itemsSelector), (item) => {
        const itemRect = item?.getBoundingClientRect();

        if (itemRect.width) {
            if (itemRect?.top < elementRect?.top) {
                position++;
            } else if (itemRect?.top === elementRect?.top) {
                if (itemRect?.left < elementRect?.left) {
                    position++;
                }
            }
        }

    });

    return position;
};
